<template>
  <div class="wraper" id="PlatForm">
    <div style="color: white;
    position: absolute;
    top: 66px;
    right: 0;">

      此功能需购买正式版本后才能使用（可定制化开发）
      <el-button type="info" style="width: 72px;
    height: 28px;
    margin-right: 15px;" @click="toMain">退出</el-button>

    </div>
    <div class="bg"></div>
    <!-- <div class="header">
      <div class="header_box">
        <div class="time">{{ nowDate }} {{ nowTime }}</div>
        <h1>智慧党建大数据统计</h1>
        <span class="el-dropdown-link tohome" @click="RouteGo('Works')">
          <i class="el-icon-switch-button el-icon--right"></i>
          退出
        </span>
      </div>
    </div>
    <div class="main_body">
      <div class="mb_structure">
        <div class="mb_structure_title">
          <div>党员结构看板</div>
        </div>
        <ul class="mb_structure_list">
          <li>
            <div class="mb_structure_subtitle">单位总人数</div>
            <div class="mb_structure_subinfo">
              {{ Numberlist.totalNum }}<em>人</em>
            </div>
          </li>
          <li>
            <div class="mb_structure_subtitle">正式党员人数</div>
            <div class="mb_structure_subinfo">
              {{ Numberlist.memberNum }}<em>人</em>
            </div>
          </li>
          <li>
            <div class="mb_structure_subtitle">预备党员人数</div>
            <div class="mb_structure_subinfo">
              {{ Numberlist.probationaryMemberNum }}<em>人</em>
            </div>
          </li>
          <li>
            <div class="mb_structure_subtitle">入党积极分子人数</div>
            <div class="mb_structure_subinfo">
              {{ Numberlist.activistMemberNum }}<em>人</em>
            </div>
          </li>
        </ul>
      </div>
      <div class="main_chart_wrap">
        <div class="aside">
          <div class="chart_box">
            <div class="title">
              党员年龄结构图
              <s class="first_point"></s>
              <s class="second_point"></s>
              <s class="third_point"></s>
              <s class="forth_point"></s>
            </div>
            <div class="chart_area">
              <CircleChart
                :MeetingStat="ageList"
                :title="ageTitle"
                :width="width"
                :height="height"
              ></CircleChart>
              <s class="first_point"></s>
              <s class="second_point"></s>
              <s class="third_point"></s>
              <s class="forth_point"></s>
            </div>
          </div>
          <div class="chart_box">
            <div class="title">
              党员男女结构图
              <s class="first_point"></s>
              <s class="second_point"></s>
              <s class="third_point"></s>
              <s class="forth_point"></s>
            </div>
            <div class="chart_area">
              <SexChart
                :MeetingStat="sexList"
                :title="sexTitle"
                :width="width"
                :height="height"
              ></SexChart>
              <s class="first_point"></s>
              <s class="second_point"></s>
              <s class="third_point"></s>
              <s class="forth_point"></s>
            </div>
          </div>
        </div>
        <div class="map">
          <div class="map_box">
            <div class="title">
              支部分布图示
              <s class="first_point"></s>
              <s class="second_point"></s>
              <s class="third_point"></s>
              <s class="forth_point"></s>
            </div>
            <div class="map_area">
              <div class="newmap">
                <div class="map">
                  <baidu-map
                    class="map"
                    v-if="branchCoord.length > 0 && centerShow"
                    :center="orgCoord[0].longitude_latitude"
                    :zoom="10"
                  >
                    <bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT"></bm-city-list>
                    <bm-navigation
                      anchor="BMAP_ANCHOR_TOP_RIGHT"
                    ></bm-navigation>
                    <div v-for="(e, i) in branchCoord" :key="i">
                      <bm-marker
                        :position="e.longitude_latitude"
                        @click="getLocationPoint(e)"
                        :dragging="false"
                      >
                        <bm-info-window
                          :show="e.flag"
                          @close="e.flag = false"
                          >{{ e.organization_name }}</bm-info-window
                        >
                      </bm-marker>
                    </div>
                    <div v-for="(e, i) in orgCoord" :key="i + '1'">
                      <bm-marker
                        :position="e.longitude_latitude"
                        @click="getLocationPoint(e)"
                        :dragging="false"
                      >
                        <bm-info-window
                          :show="e.flag"
                          @close="e.flag = false"
                          >{{ e.organization_name }}</bm-info-window
                        >
                      </bm-marker>
                    </div>
                  </baidu-map>
                  <div
                    v-if="branchCoord.length === 0 && centerShow"
                    style="
                      padding: 50px 0 0;
                      text-align: center;
                      font-size: 48px;
                    "
                  >
                    暂无支部进行了定位
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="aside">
          <div class="chart_box">
            <div class="title">
              党员学历统计图
              <s class="first_point"></s>
              <s class="second_point"></s>
              <s class="third_point"></s>
              <s class="forth_point"></s>
            </div>
            <div class="chart_area">
              <EducationChart :MeetingStat="educationList"></EducationChart>
              <s class="first_point"></s>
              <s class="second_point"></s>
              <s class="third_point"></s>
              <s class="forth_point"></s>
            </div>
          </div>
          <div class="chart_box">
            <div class="title">
              组织生活会议统计图(今年)
              <s class="first_point"></s>
              <s class="second_point"></s>
              <s class="third_point"></s>
              <s class="forth_point"></s>
            </div>
            <div class="chart_area">
              <YearMeetingChart :MeetingStat="MeetingStat" />
              <s class="first_point"></s>
              <s class="second_point"></s>
              <s class="third_point"></s>
              <s class="forth_point"></s>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import { deepClone } from "@/assets/js/utils"
import PieChat from "@/components/Echarts/PieChat";
import CircleChart from "@/components/Echarts/CircleChart";
import EducationChart from "@/components/Echarts/EducationChart";
import SexChart from "@/components/Echarts/SexChart";
import YearMeetingChart from "@/components/Echarts/YearMeetingChart";
import Columnar from "@/components/Echarts/Columnar";
import { getsMemberOrganizationApi } from "@/network/api/branch";
import { getMeetingStatapi, getNumberapi } from "@/network/api/home";
export default {
  components: {
    PieChat,
    Columnar,
    CircleChart,
    EducationChart,
    SexChart,
    YearMeetingChart,
  },
  created() {
    this.timer = setInterval(this.getTime, 1000);
    this.getsMemberOrganization();
    this.getMeetingData();
    this.getNum();
    this.getCenter()
  },
  methods: {
    toMain(){
      this.RouteGo('Works')
    },
    infoWindowClose() {
      this.show = false
    },
    infoWindowOpen() {
      this.show = true
    },
    getLocationPoint(e) {
      e.flag = true
      let that = this;
      this.coordinate = e.longitude_latitude
      setTimeout(() => {
        that.show = true
      }, 50)
    },
    async getCenter() {
      const that = this
      // 取党委设置的城市和坐标
      const data = await this.PublicApi(
        "/admin/organization/getMapInfo"
      )
      this.centerShow = true
      if (data.data.branch.length === 0) {
        this.branchCoord = {
          address: "",
          is_com: 0,
          longitude_latitude: { lng: 104.785481, lat: 31.505511, of: "inner" },
          lat: 31.505511,
          lng: 104.785481,
          of: "inner",
          organization_name: ""
        }
      } else {
        this.branchCoord = data.data.branch
      }

      this.orgCoord = data.data.is_com
      for (let i in this.branchCoord) {
        this.branchCoord[i].flag = false
      }
      for (let i in this.orgCoord) {
        this.orgCoord[i].flag = true
      }
      this.coordinate = data.data.longitude_latitude
      this.address = data.data.address
      this.center = this.coordinate
      this.info = data.data.address
      this.show = true
    },
    async getNum() {
      let data = await getNumberapi();
      this.Numberlist = data.data;
      // console.log(1,this.Numberlist)
    },
    async getMeetingData() {
      var date = new Date();
      // let data02 = await getMeetingStatapi({ month: `${date.getFullYear()}-12`, nearMonth: 12 });
      let data02 = await getMeetingStatapi({
        month: `${date.getFullYear()}-12`,
        nearMonth: 12,
      });
      // console.log(1,data02)
      this.MeetingStat = data02.data;
      console.log(22, this.MeetingStat);
      // this.MeetingStat.xAxis = ["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"]
      this.MeetingStat.total = data02.data.all.data;
    },
    async getsMemberOrganization() {
      let res = await getsMemberOrganizationApi();
      let data = res.data;
      this.educationList = {
        xAxis: data.education_x,
        series: data.education_y,
      };
      let sex = [];
      sex.push(
        { value: data.nan_num, name: "男" },
        { value: data.nv_num, name: "女" }
      );
      let sexList = { data: sex };
      this.sexList = sexList;
      this.memberList = {
        data: [
          { value: data.member, name: "党员" },
          { value: data.other_member, name: "非党员" },
        ],
      };
      this.ageList = { data: data.ageNum };
    },
    getTime() {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hour = date.getHours();
      const minute = date.getMinutes();
      const second = date.getSeconds();
      const str = "";
      if (this.hour > 12) {
        this.hour -= 12;
        this.str = " AM";
      } else {
        this.str = " PM";
      }
      this.month = check(month);
      this.day = check(day);
      this.hour = check(hour);
      this.minute = check(minute);
      this.second = check(second);
      function check(i) {
        const num = i < 10 ? "0" + i : i;
        return num;
      }
      this.nowDate = year + "年" + this.month + "月" + this.day + "日";
      this.nowTime =
        this.hour + ":" + this.minute + ":" + this.second + this.str;
    },
  },
  data() {
    return {
      centerShow: false,
      // 地图中心点
      center: "绵阳",
      // 地理坐标
      coordinate: { lng: 116.404, lat: 39.915 },
      // 信息展示
      show: false,
      // 信息
      info: "",

      branchCoord: [],
      orgCoord: [],
      address: "",
      Numberlist: {},
      markerPoint: [
        {
          lng: 116.404,
          lat: 39.915,
        },
        {
          lng: 118.404,
          lat: 18.915,
        },
        {
          lng: 85.404,
          lat: 76.915,
        },
      ],
      location: [
        {
          lng: 116.404,
          lat: 39.915,
        },
        {
          lng: 118.404,
          lat: 18.915,
        },
        {
          lng: 85.404,
          lat: 76.915,
        },
      ],
      zoom: 12.8,
      addressKeyword: "",
      educationList: { xAxis: [], series: [] },
      sexList: { data: [] },
      memberList: { data: [] },
      ageList: { data: [] },
      monthList: {},
      sexTitle: "男女统计",
      memberTitle: "党员分布统计",
      ageTitle: "年龄分布统计",
      width: "100%",
      height: "100%",
      nowDate: null, //存放年月日变量
      nowTime: null, //存放时分秒变量
      timer: "", //定义一个定时器的变量
      currentTime: new Date(), // 获取当前时间
      MeetingStat: {}, //会议类型统计图数据
    };
  },
};
</script>
<style lang="less" scoped>
body,
html {
  height: 100%;
  width: 100%;
  overflow: hidden;
}
* {
  margin: 0;
  padding: 0;
}
.wraper {
  height: 100%;
  background: url("../../../assets/images/bsg.png") repeat;
}
#PlatForm {
  .header {
    height: 8.33%;
    background: url("../../../assets/images/tjh_bg.png") no-repeat center center;
    background-size: 100% 100%;
    .tohome {
      cursor: pointer;
      position: fixed;
      right: calc(1 / 19.2 * 15vw);
      top: calc(1 / 10.8 * 10vh);
      font-size: calc(1 / 10.8 * 18vh);
      color: #00ccff;
      .el-icon-switch-button {
        font-size: calc(1 / 10.8 * 18vh);
      }
    }
    .header_box {
      height: 50%;
      //border-bottom: 1px #04497c solid;
      padding: 0 2%;
      position: relative;
    }
    h1 {
      text-align: center;
      width: 28.12%;
      font-size: calc(1 / 10.8 * 48vh);
      position: absolute;
      color: #00ccff;
      left: 50%;
      margin-left: -14.06%;
      top: 0%;
      background-size: 100% 100%;
      padding-top: calc(1 / 10.8 * 10vh);
      padding-bottom: calc(1 / 10.8 * 20vh);
    }
    .time {
      height: 100%;
      display: flex;
      align-items: center;
      font-size: calc(1 / 10.8 * 16vh);
      color: #00ccff;
    }
  }
  .main_body {
    height: 88.88%;
    .mb_structure {
      display: flex;
      height: 20%;
      .mb_structure_title {
        margin-left: 2%;
        width: 21%;
        height: 100%;
        > div {
          background: url("../../../assets/images/tjh_bg2.png") no-repeat center
            center;
          height: 100%;
          background-size: contain;
          padding-left: calc(1 / 19.2 * 120vw);
          font-size: calc(1 / 10.8 * 28vh);
          box-sizing: border-box;
          padding-top: calc(1 / 10.8 * 72vh);
          color: #fff;
          margin-right: calc(1 / 19.2 * 45vw);
        }
      }
      > ul {
        flex: 1;
        margin-right: 2%;
        display: flex;
        > li {
          width: 25%;
          box-sizing: border-box;
          padding-left: 3%;
          .mb_structure_subtitle {
            color: #fff;
            font-size: calc(1 / 10.8 * 20vh);
            margin-top: calc(1 / 10.8 * 47vh);
          }
          .mb_structure_subinfo {
            color: #00ccff;
            font-size: calc(1 / 10.8 * 48vh);
            margin-top: calc(1 / 10.8 * 15vh);
            > em {
              color: #ffa200;
              font-size: calc(1 / 10.8 * 28vh);
            }
          }
        }
      }
    }
    .main_chart_wrap {
      height: 80%;
      display: flex;
      .aside {
        width: 21% !important;
        padding: 0 !important;
        margin-left: 2%;
        .chart_box {
          height: calc(1 / 10.8 * 375vh);
          .title {
            height: calc(1 / 10.8 * 46vh);
            line-height: calc(1 / 10.8 * 46vh);
            padding-left: calc(1 / 19.2 * 22vw);
            font-size: calc(1 / 10.8 * 20vh);
            color: #00ccff;
            background: url("../../../assets/images/orbox.png") repeat;
            position: relative;
            border: 1px #063351 solid;
          }
          .chart_area {
            height: calc(1 / 10.8 * 318vh);
            margin-top: calc(1 / 10.8 * 12vh);
            position: relative;
            background: url("../../../assets/images/orbox.png") repeat;
            border: 1px #063351 solid;
          }
        }
        .chart_box + .chart_box {
          margin-top: calc(1 / 10.8 * 20vh);
        }
      }
      .map {
        flex: 1;
        .map_box {
          .title {
            font-size: calc(1 / 10.8 * 28vh);
            color: #fff;
            text-align: center;
            width: calc(1 / 19.2 * 400vw);
            height: calc(1 / 10.8 * 45vh);
            line-height: calc(1 / 10.8 * 45vh);
            margin: 0 auto;
            background: rgba(3, 110, 154, 0.1);
            position: relative;
            border: 1px #063351 solid;
          }
          .map_area {
            width: 90%;
            margin: 0 auto;
            margin-top: calc(1 / 10.8 * 12vh);
            height: calc(1 / 10.8 * 713vh);
            .newmap {
              width: 100%;
              height: 100%;
              box-sizing: border-box;
              background: #fff;
              .map {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }
      .map + .aside {
        margin-left: 0;
        margin-right: 2%;
      }
    }
  }
}
.first_point,
.second_point,
.third_point,
.forth_point {
  width: calc(1 / 10.8 * 3vh);
  height: calc(1 / 10.8 * 3vh);
  background: #00d7ff;
  position: absolute;
}
.first_point {
  left: 0;
  top: 0;
}
.second_point {
  right: 0;
  top: 0;
}
.third_point {
  left: 0;
  bottom: 0;
}
.forth_point {
  right: 0;
  bottom: 0;
}
.bg{
  background-image: url("../../../assets/images/bigdata.jpg");
  width: 1920px;
  height: 1080px;
  background-repeat: no-repeat;
  background-position: top;
}
</style>


// WEBPACK FOOTER //
// src/views/Works/BranchHome/index.vue